import { DutyOfCareSubscriptionPackageType } from '../../../../models/enums/DutyOfCareSubscriptionPackageType';
import { getOptionsFromEnumValues } from '../../../../utils/getOptionsFromEnum';

export const preparePackagesOptions = (
  packages: DutyOfCareSubscriptionPackageType[],
) => getOptionsFromEnumValues(packages, 'duty-of-care-subscription-packages');
